import { render } from "./chat-bot.vue?vue&type=template&id=8351a562&scoped=true"
import script from "./chat-bot.vue?vue&type=script&lang=js"
export * from "./chat-bot.vue?vue&type=script&lang=js"

import "./chat-bot.vue?vue&type=style&index=0&id=8351a562&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8351a562"]])

export default __exports__